import { deepExtract } from 'helpers/deep';
import { SearchLocation } from '../models/SearchLocation';
import { LOCATION_TYPES } from '../Map/SearchMap.constants';
import { DEFAULT_GEOLOCATION } from '../Search.constants';

export const SET_OPEN_PANEL = 'classpass/searchbox/SET_OPEN_PANEL';
export const CLOSE_OPEN_PANEL = 'classpass/searchbox/CLOSE_OPEN_PANEL';
export const CLEAR_KEYWORD = 'classpass/searchbox/CLEAR_KEYWORD';
export const CLEAR_LOCATION = 'classpass/searchbox/CLEAR_LOCATION';
export const SET_KEYWORD_VALUE = 'classpass/searchbox/SET_KEYWORD_VALUE';
export const SET_LOCATION_VALUE = 'classpass/searchbox/SET_LOCATION_VALUE';
export const SET_DEFAULT_LOCATION = 'classpass/searchbox/SET_DEFAULT_LOCATION';
export const SET_SELECTED_LOCATION = 'classpass/searchbox/SET_SELECTED_LOCATION';
const SET_KEYWORD_KEY = 'classpass/searchbox/SET_KEYWORD_KEY';
const SET_LOCATION_KEY = 'classpass/searchbox/SET_LOCATION_KEY';
export const SET_KEYWORD = 'classpass/searchbox/SET_KEYWORD';
const SET_LOCATION_TIMEZONE = 'classpass/searchbox/SET_LOCATION_TIMEZONE';

export const SEARCH_BOX_WRITE_ACTIONS = [CLEAR_KEYWORD, CLEAR_LOCATION, SET_KEYWORD];

export const closeOpenPanel = () => ({ type: CLOSE_OPEN_PANEL, key: 'openPanel', value: null });
export const setOpenPanel = value => ({ type: SET_OPEN_PANEL, key: 'openPanel', value });
export const setKeywordFieldValue = value => ({ type: SET_KEYWORD_VALUE, key: 'keywordFieldValue', value });
export const setKeyword = (value, options) => ({ type: SET_KEYWORD, value, data: { options } });
export const setKeywordKey = value => ({ type: SET_KEYWORD_KEY, key: 'keywordKey', value });
export const clearKeywordField = options => ({ type: CLEAR_KEYWORD, data: { options } });

export const setLocationFieldValue = value => ({ type: SET_LOCATION_VALUE, value, key: 'locationFieldValue' });
export const setLocationKey = value => ({ type: SET_LOCATION_KEY, key: 'locationKey', value });
export const setDefaultLocation = location => ({ type: SET_DEFAULT_LOCATION, location });
export const setSelectedLocation = location => ({ type: SET_SELECTED_LOCATION, location });
export const setLocationTimezone = value => ({ type: SET_LOCATION_TIMEZONE, value });
export const clearLocationField = () => ({ type: CLEAR_LOCATION });
export const selectSearchBoxState = state => state.features.searchBox || {};
export const selectOpenPanel = state => selectSearchBoxState(state).openPanel;
export const selectSelectedKeywordId = state => selectSearchBoxState(state).keywordSelectedId;
export const selectSelectedKeywordType = state => selectSearchBoxState(state).keywordSelectedType;
export const selectDefaultLocation = state => selectSearchBoxState(state).defaultLocation;
export const selectSelectedLocation = state => selectSearchBoxState(state).selectedLocation;
export const selectPreviousLocation = state => selectSearchBoxState(state).previousLocation;
export const selectActiveLocation = state => selectSelectedLocation(state) || selectDefaultLocation(state);
export const selectKeywordSearchBoxText = state => selectSearchBoxState(state).keywordDisplayValue;
export const selectKeywordOriginalValue = state => selectSearchBoxState(state).keywordOriginalValue;
export const selectLocationSearchBoxText = state => {
  const { selectedLocation, defaultLocation } = selectSearchBoxState(state);
  return deepExtract('locationName', selectedLocation || defaultLocation, '');
};

const initialState = {
  keywordKey: '',
  keywordFieldValue: '',
  keywordDisplayValue: '',
  keywordSelectedId: '',
  keywordSelectedType: null,
  locationFieldValue: '',
  locationKey: '',
  openPanel: null,
  selectedLocation: null,
  defaultLocation: new SearchLocation(DEFAULT_GEOLOCATION),
  previousLocation: null,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CLOSE_OPEN_PANEL:
    case SET_OPEN_PANEL:
    case SET_KEYWORD_KEY:
    case SET_KEYWORD_VALUE:
    case SET_LOCATION_KEY:
    case SET_LOCATION_VALUE:
      return {
        ...state,
        [action.key]: action.value,
      };
    case SET_KEYWORD:
      return {
        ...state,
        keywordDisplayValue: action.value.name,
        keywordSelectedId: action.value.id,
        keywordSelectedType: action.value.type,
        keywordOriginalValue: deepExtract('value.analytics_metadata.synonym_original_name', action),
      };
    case SET_DEFAULT_LOCATION:
      return {
        ...state,
        defaultLocation: {
          ...action.location,
          isMapSearch: deepExtract('location.type', action) === LOCATION_TYPES.mapSearch,
        },
      };
    case SET_SELECTED_LOCATION:
      return {
        ...state,
        previousLocation: { ...(state.selectedLocation || {}) },
        selectedLocation: {
          ...action.location,
          isMapSearch: deepExtract('location.type', action) === LOCATION_TYPES.mapSearch,
        },
      };
    case SET_LOCATION_TIMEZONE:
      return {
        ...state,
        selectedLocation: {
          ...state.selectedLocation,
          timezone: action.value,
        },
      };
    case CLEAR_KEYWORD:
      return {
        ...state,
        keywordDisplayValue: '',
        keywordFieldValue: '',
        keywordSelectedId: '',
      };
    case CLEAR_LOCATION:
      return {
        ...state,
        previousLocation: { ...(state.selectedLocation || {}) },
        locationFieldValue: '',
        selectedLocation: null,
      };
    default:
      return state;
  }
}
